import DonationFrequency from './DonationFrequency';

export default DonationFrequency;
